module.exports = __webpack_public_path__ + "check-insurance-mobile___T275g.svg";